/*eslint-disable */
import React, { useState, useEffect } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi, Container, Dropdown, Grid, Checkbox } from "semantic-ui-react";
// import CardSection from '../UiComponents/cardSection';
import { translate } from "react-i18next";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import { isEmpty } from "lodash";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { connect } from "react-redux";
import { AllRegex } from "../../utils/validation";
import UserAlerts from "./userAlerts";
import UserBranch from '../linkuserBranch/userBranch';
import { faFolderMinus } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios'
import { LOCAL_STORAGE, FEATURES } from '../../utils/constant'
import MyMovementType from "../dynamicComponent/myMovementTypes";
import DeleteAxios from "../axiosComponent/delete";
import MandatoryMark from "../common/mandatorymark";

const InsertUsers = ({
  values,
  setFieldValue,
  t,
  touched,
  errors,
  editData,
  action,
  userMovementTypeIds
}) => {
  const [roleTypeList, setroleTypeList] = useState([]);
  const [userMovementTypes, setUserMovementTypes] = useState([])
  const [businessUnitOptions, setBusinessUnitOptions] = useState([])

  useEffect(() => {
    getuUserRoleList();
    getBusinessUnits()
  }, []);

  const getuUserRoleList = () => {
    ReadAxios({ url: `roles`, readItems: { module_name: "TA" } }).then((result) => {
      let dataArray = isEmpty(result) ? [] : result.data.resultSet;
      setroleTypeList(
        dataArray.map((item, index) => {
          return {
            raw: { ...item },
            index,
            text: item.role,
            key: item.roleId,
            value: item.roleId,
          };
        })
      );
    });
  };

  const getBusinessUnits = () => {
    if(FEATURES.userBusinessUnitField) {
      ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/businessUnitMaster`, readItems: { module_name: "TA" } }).then((result) => {
        let dataArray =  result.data?.resultSet || [];
        let options = dataArray.map((item, index) => {
          return {
            key: index, 
            text: item.businessUnitName,
            value: item.businessUnitId,
            raw : item
          }
        })
        setBusinessUnitOptions(options)
      });
    }
  };

  const setroleValue = (name, data) => {
    setFieldValue("skuTypeId", data.value);
    if (data.value) {
      let userRole = data.options.find((ele) => ele.value == data.value).value;
      if (data.value) {
        setFieldValue("roleId", userRole);
      } else {
        setFieldValue("roleId", "");
      }
    }
  };

  const checkForbussinessUnit = (name, data) => {
    setFieldValue("businessUnitId", data.value);
    let rawdata = businessUnitOptions.find((obj)=>obj.value === data.value)?.raw
    rawdata && setFieldValue("businessUnit", rawdata.businessUnitCode);
  }

  return (
    <React.Fragment>
      <Formiker>
        <div className="container-fluid animated slideInDown pad w3-white">
          <div className="m-3 pl-3">
            <div className="ui form">
              <FormUi.Group inline>
              <FormUi.Field  width={2}>
                  <label className="labelName">
                    {t("create.user_code.title") || "User Code"}{}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4}>
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="userCode"
                    placeholder={
                      t("create.user_code.placeholder") || "User Code"
                    }
                    disabled={(editData?.userCode) ? true : false}
                    value={values.userCode}
                  />
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.username.title") || "Username"}{" "} <MandatoryMark/>
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  error={touched.userName && errors.userName ? true : false}
                  className="display-grid-center-imp"
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="userName"
                    placeholder={t("create.username.placeholder") || "Username"}
                  />
                  {touched.userName && errors.userName ? (
                    <div className="error-msg">
                      {t(`create.username.error_msg.${errors.userName}`) ||
                        errors.userName}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>
              <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.user_real_name.title") || "User Real Name"}{" "} <MandatoryMark/>
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={touched.realName && errors.realName ? true : false}
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="realName"
                    placeholder={
                      t("create.user_real_name.placeholder") || "Full Name"
                    }
                  />
                  {touched.realName && errors.realName ? (
                    <div className="error-msg">
                      {t(
                        `create.user_real_name.error_msg.${errors.realName}`
                      ) || errors.realName}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.email.title") || "Email"} {" "} <MandatoryMark/>
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={touched.email && errors.email ? true : false}
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="email"
                    placeholder={t("create.email") || "email"}
                  />
                  {touched.email && errors.email ? (
                    <div className="error-msg">
                      {t(`create.email.error_msg.${errors.email}`) ||
                        errors.email}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline>  
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.mobile_no.title") || "Mobile No."}{" "} <MandatoryMark/>
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={touched.mobileNo && errors.mobileNo ? true : false}
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="mobileNo"
                    placeholder={
                      t("create.mobile_no.placeholder") || "Mobile No."
                    }
                  />
                  {touched.mobileNo && errors.mobileNo ? (
                    <div className="error-msg">
                      {t(`create.mobile_no.error_msg.${errors.mobileNo}`) ||
                        errors.mobileNo}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.password.title") || "Password"}{" "} <MandatoryMark/>
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  error={touched.password && errors.password ? true : false}
                  className="display-grid-center-imp"
                >
                  <Fieldmik
                    type="password"
                    className="ui input"
                    name="password"
                    // disabled={editData.username ? true : false}
                    placeholder={t("create.password.placeholder") || "Password"}
                  />
                  {touched.password && errors.password ? (
                    <div className="error-msg">
                      {t(`create.password.error_msg.${errors.password}`) ||
                        errors.password}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>
              <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.user_role.title") || "User Role"}{" "} <MandatoryMark/>
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={
                    touched.roleId && errors.roleId ? true : false
                  }
                >
                  <Dropdown
                    name="roleId"
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    upward
                    placeholder={
                      t("create.user_role.placeholder") || "User Role"
                    }
                    onChange={(name, data) => setroleValue(name, data)}
                    options={roleTypeList}
                    value={values.roleId}
                  />
                  {console.log('errors.roleId', errors.user_role)}
                  {touched.roleId && errors.roleId ? (
                    <div className="error-msg">
                      {t(
                        `create.user_role.error_msg.${errors.roleId}`
                      ) || errors.roleId}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field  width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.movement_type.title") || "Movement Type"}{" "}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  error={
                    touched.movementTypeIds && errors.movementTypeIds ? true : false
                  }
                >

                  <Fieldmik
                    component={MyMovementType}
                    name="movementTypeIds"
                    multiSelect={true}
                    multiple
                    userId = {values.userId}
                    value={values.movementTypeIds}
                    nameValue="movementTypes"
                    upward
                    placeholder={
                      t("create.movement_type.placeholder") || "Select Movement Type"
                    }
                  />

                  {touched.movementTypeIds && errors.movementTypeIds ? (
                    <div>
                      {errors.movementTypeIds}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              {FEATURES.userBusinessUnitField ? (
                <>
                  <FormUi.Group>
                    <FormUi.Field width={2}>
                      <label className="labelName mt-2">
                        {t("create.businessUnit.title") || "Password"}{" "}
                        {/* <MandatoryMark /> */}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      error={
                        touched.businessUnit && errors.businessUnit ? true : false
                      }
                    >
                      <Dropdown
                        name="businessUnit"
                        clearable
                        style={{ width: "100%", fontWeight: "normal" }}
                        // disabled={disable}
                        selection
                        placeholder={
                          t("create.businessUnit.placeholder") || "Business unit"
                        }
                        onChange={(name, data) => checkForbussinessUnit(name, data)}
                        options={businessUnitOptions}
                        upward
                        value={values.businessUnitId}
                      />
                      {touched.businessUnit && errors.businessUnit ? (
                        <div>
                          {t(`create.businessUnit.error_msg.${errors.businessUnit}`) ||
                            errors.businessUnit}
                        </div>
                      ) : null}
                    </FormUi.Field>
                  </FormUi.Group>
                </>
              ) : (
                null
              )}
            </div>
          </div>
        </div>



        {action == "edit_title" ? (
          <UserAlerts
            userInfo={editData}
            setFieldValue={setFieldValue}
          />
        ) : (null)}

        {action == "edit_title" ? (
          <UserBranch userInfo={editData} />
        ) : (null)}


        <Container className="p-3" textAlign="center">
          <button
            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
            type="submit"
          >
            {t("create.action_button.submit") || "Submit"}
          </button>
        </Container>



      </Formiker>
    </React.Fragment>
  );
};

const FormikUsers = withFormik({
  validationSchema: yup.object({
    userName: yup
      .string()
      .required("required")
      .matches(AllRegex.Username, "username"),
    realName: yup.string().required("required").matches(AllRegex.Name, "name"),
    email: yup.string().required("required").matches(AllRegex.Email, "email"),
    mobileNo: yup
      .string()
      .required("required")
      .matches(AllRegex.MobileNumber, "phone"),
    password: yup.string().required("required"),
    businessUnit: yup.string().optional().nullable(),
    roleId: yup.number().required("required"),
  }),
  enableReinitialize: true,
  mapPropsToValues: (props) => ({
    userName: props.editData.username || "",
    roleId: props.editData.roleId || "",
    userCode: props.editData.userCode || "",
    realName: props.editData.realname || "",
    email: props.editData.email_address || "",
    mobileNo: props.editData.mobile_number || "",
    password: props.editData.password || "",
    businessUnit: props.editData.businessUnit || "",
    businessUnitId : props.editData.businessUnitId ||"",
    movementTypeIds:props.userMovementTypeIds||[],
    movementTypes:"",
    emailFlag : props.editData.emailFlag ||"",
    smsFlag : props.editData.smsFlag ||"",
  }),
  async handleSubmit(values, { props }) {
    if (props.editData.u_id) {
      await UpdateAxios({
        url: "userMaster",
        payload: Object.assign({}, values, { userKey: props.editData.userKey }),
        uniqueId: props.editData.u_id,
      })
        .then(async(res) => {
          let errorObj = false , validationMessage = ''
          if (res.data.status === 200) {
              try{
                await DeleteAxios({
              url:"userMovementTypeMapping",
              uniqueId:props.editData.u_id
            })
          }catch(err){
            console.log(err);
          }
            if (values.movementTypeIds.length > 0) {
             try{ 

              await values.movementTypeIds.map(async (id) => {
                let movementTypePayload = {
                  mainUserId : props.editData.u_id,
                  movementTypeId : id
                }
              let movementTypeMapping =  await CreateAxios({
                  url: "userMovementTypeMapping",
                  payload: { ...movementTypePayload },
                })
                if(movementTypeMapping.data.status !== 200){
                  let movementType = values.movementTypes.find((data)=>data.value===id).name
                  errorObj = true
                  validationMessage=`User Updated, Error in mapping ${movementType} to ${values.userName}`
                }

              })
            }catch(err){
              console.log(err);
            }
            }
            if(errorObj){
              let alert = {
                type: "error",
                messageHeader: "Error",
                messageBody: validationMessage,
              };
              props.errorAlertDispatcher(alert);
            }else{
              let alert = {
                type: "success",
                messageHeader: "Success",
                messageBody: res.data.message,
              };
              props.successAlertDispatcher(alert);
              props.onFormSubmit();
              
            }
          }
        })
        .catch((err) => {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.data.message,
          };
          console.log(err);
          props.errorAlertDispatcher(alert);
        });
    } else {

      await CreateAxios({
        url: "userMaster",
        payload: { ...values },
      })
        .then((res) => {
          if (res.data.status === 200) {
            if (values.movementTypeIds.length > 0) {
             try{ 
              values.movementTypeIds.map(async (id) => {
                let movementTypePayload = {
                  mainUserId : res.data.lastInsertedId,
                  movementTypeId : id
                }
               await CreateAxios({
                  url: "userMovementTypeMapping",
                  payload: { ...movementTypePayload },
                })

              })
            }catch(err){
              console.log(err);
            }
            }
            let alert = {
              type: "success",
              messageHeader: "Success",
              messageBody: res.data.message,
            };
            props.successAlertDispatcher(alert);
            props.onFormSubmit();
          }
        })
        .catch((err) => {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.data.message,
          };
          props.errorAlertDispatcher(alert);
        });
    }
  },
})(InsertUsers);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("create_user")(FormikUsers)
);
